<p-panel [style]="{ 'margin-top': '1em' }" styleClass="panel-shadow">
  <p-header>
    <div class="panel-header">Fuel Levels</div>
  </p-header>

  <div
    *ngIf="awaitingAllocation; else showDetails"
    class="py-3 text-center"
    style="font-weight: 500; color: #999"
  >
    Awaiting Allocation
  </div>

  <ng-template #showDetails>
    <div class="pb-1" *ngIf="fuelLevelTask != null">
      <form [formGroup]="fuelForm">
        <div class="flex flex-wrap grid-gap-5">
          <div class="flex-grow-1 style2023" style="margin-top: 0.5em">
            <div class="input-group">
              <div class="input-group-prepend white-space-nowrap">Pick-up</div>
              <div
                class="input-group-item"
                *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
              >
                <div *ngIf="fuelLevelTask?.isElectric" class="percent-wrapper">
                  <input formControlName="pickupFuel" pInputText min="0" type="number" max="100" />
                </div>
                <p-dropdown
                  *ngIf="!fuelLevelTask?.isElectric"
                  [options]="fuelLevelsSelectItems"
                  [style]="{ width: '100%', 'min-width': '0px' }"
                  formControlName="pickupFuel"
                ></p-dropdown>
              </div>
              <div
                *ngIf="organisationTypeId != OrganisationTypeEnum.Engineius"
                class="input-group-item"
              >
                {{
                  fuelLevelTask?.isElectric
                    ? fuelLevelTask.pickupFuel
                    : getFuelLevel(fuelLevelTask.pickupFuel)
                }}
              </div>
            </div>
          </div>

          <div class="flex-grow-1 style2023" style="margin-top: 0.5em">
            <div class="input-group">
              <div class="input-group-prepend white-space-nowrap">Drop-off</div>
              <div
                class="input-group-item"
                *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
              >
                <div *ngIf="fuelLevelTask?.isElectric" class="percent-wrapper">
                  <input formControlName="dropoffFuel" pInputText min="0" type="number" max="100" />
                </div>
                <p-dropdown
                  *ngIf="!fuelLevelTask?.isElectric"
                  [options]="fuelLevelsSelectItems"
                  [style]="{ width: '100%', 'min-width': '0px' }"
                  formControlName="dropoffFuel"
                ></p-dropdown>
              </div>
              <div
                *ngIf="organisationTypeId != OrganisationTypeEnum.Engineius"
                class="input-group-item"
              >
                {{
                  fuelLevelTask?.isElectric
                    ? fuelLevelTask.dropoffFuel
                    : getFuelLevel(fuelLevelTask.dropoffFuel)
                }}
              </div>
            </div>
          </div>
        </div>
      </form>

      <div
        *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius && fuelForm.dirty"
        class="mt-2 text-right"
      >
        <button pButton label="Save" style="margin-left: 0" (click)="saveFuelReadings()"></button>
      </div>
    </div>
  </ng-template>
</p-panel>
